import axios from 'axios'
import { URL, apiToken } from './global.env'

const apiClient = axios.create({
  baseURL: URL,
  withCredentials: false,
  headers: {
    'api-token': apiToken
  }
})

export default {
  /**
   * Call to get list of tiers
   *
   * @returns {Promise}
   */
  getTiers () {
    return apiClient({
      method: 'get',
      url: '/api/v1/tiers/',
      headers: {
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to create a new tiers
   *
   * @returns {Promise}
   */
  createTier (data) {
    return apiClient({
      method: 'post',
      data: data,
      url: '/api/v1/tiers/',
      headers: {
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to edit an tiers
   *
   * @returns {Promise}
   */
  editTier (id, data) {
    return apiClient({
      method: 'patch',
      data: data,
      url: `/api/v1/tiers/${id}/`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to delete an tiers
   *
   * @returns {Promise}
   */
  deleteTier (id) {
    return apiClient({
      method: 'delete',
      url: `/api/v1/tiers/${id}/`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  /**
   * Call to delete an tiers
   *
   * @returns {Promise}
   */
  getTier (id) {
    return apiClient({
      method: 'get',
      url: `/api/v1/tiers/${id}/`,
      headers: {
        'api-token': apiToken
      }
    })
  },
  getTierByPrizingId (prizingId) {
    return apiClient({
      method: 'get',
      url: `/api/v1/prizing/${prizingId}/tiers/`,
      headers: {
        'api-token': apiToken
      }
    })
  }
}
